import React from 'react';
import { useTranslation } from 'react-i18next';

import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import EditFormDepartments from '../../../HR/Departments/EditDepartments/EditFormDepartments';
import useOrganizationDetails from '../../../../hooks/HR/use-organization-details';

const UppdateWorkShop = () => {
  const { Organization, loading } = useOrganizationDetails();
  // const { Organization, loading } = useOrganizationDetails();

  //______________________________
  var BcrumbList = [
    {
      name: 'Home',
     link: ':moduleHome'
    },
    {
      name: 'Workshops',
      link: '/FLEETSettings/WorkShop'
    },
    {
      name: 'Edit',
      link: null
    }
  ];
  return (
    <div>
      <Breadcrumb BreadcrumbList={BcrumbList} PageName='EditWorkshop' />

      <EditFormDepartments Organization={Organization} loading={loading} type='160' />
    </div>
  );
};

export default UppdateWorkShop;
